import React from 'react'

/* handleChange is optional */
export function BuildSelect(props) {
    const { id, size, jsonArray, handleChange } = props;
    if (!jsonArray || jsonArray.length === 0) return null;

    const handleSelectionChange = () => {
        if (handleChange) {
            handleChange();
        }
    };

    return (
    	<React.Fragment>
            <select id={id} size={size || null} onChange={handleSelectionChange}>
	            {jsonArray.map(item => {
	                return <option key={item.key} value={item.key} {...item.selected}>{item.value}</option>
	            })} 
			</select>
		</React.Fragment>
	);
};
